module.exports = __webpack_public_path__ + "img/menu.efe1fa58.svg";